

 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 
 const PostDeleteMainTableRetailById = (data: any) =>
 request({
   url: ApiURL.Command.PostMainRetailDbRemoveById,
   method: RequestType.POST,
   data,
 });
 const PostDeleteTransferTableRetailById = (data: any) =>
  request({
    url: ApiURL.Command.PostTransferRetailDbRemoveById,
    method: RequestType.POST,
    data,
  }); 



const RetailCommand = {
  PostDeleteMainTableRetailById,
  PostDeleteTransferTableRetailById 
};

export default RetailCommand;
